import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/dashboard/fantasy/fixture/contest-winner-management-v2'
)({
  component: ContestWinnerManagementV2Layout,
});

function ContestWinnerManagementV2Layout() {
  return (
    <div className='flex flex-col w-full p-8 space-y-6'>
      <h1 className='text-2xl font-base'>Contest Winner Management</h1>
      <Outlet />
    </div>
  );
}
